import UserCard from "./UserCard";
import { UserType } from "../../../types/userType";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { chatContacts } from "../../../functions/chatsContact";

const SidebarBody = () => {
  const { id } = useParams();
  const getUsers = useSelector((state: RootState) => state.users.users);
  const messages = useSelector((state: RootState) => state.messages.messages);
  const searchQuery = useSelector(
    (state: RootState) => state.users.searchQuery
  );

  return (
    <div className="sm:h-full xl:h-[635px] 2xl:h-[685px] sm:overflow-auto md:overflow-hidden sm:overflow-y-auto md:overflow-y-scroll sm:p-1 md:p-3">
      {searchQuery.length !== 0 || chatContacts(messages).length === 0 ? (
        ""
      ) : (
        <>
          <div className="sm:text-lg md:text-xl font-semibold p-2 py-5 pt-3 text-violet-500">
            Chats
          </div>
          <div className="flex flex-col gap-2 h-max">
            {chatContacts(messages).map((item: UserType, index: number) => (
              <UserCard
                selected={id === `${item.id}` ? true : false}
                key={index}
                data={item}
                isContact={false}
              />
            ))}
          </div>
        </>
      )}
      <div className="sm:text-lg md:text-xl font-semibold p-2 py-5 text-violet-500">
        Contacts
      </div>
      <div className="flex flex-col gap-2 sm:h-full md:h-max">
        {getUsers.map((item: UserType, index: number) => (
          <UserCard selected={false} key={index} data={item} isContact={true} />
        ))}
      </div>
    </div>
  );
};

export default SidebarBody;
